export default {
  // Sự nghiệp thu
  BUSINESS_INCOME: 1,

  // Loại thu
  REVENUE_TYPE: 2,

  // Nội dung thu
  REVENUE_CONTENT: 3,

  // Tính chất hoạt động
  OPERATION_TYPE: 4,

  // Loại chi
  EXPENSE_TYPE: 5,

  // Lĩnh vực
  FIELD: 6,

  //Đơn vị
  ORGANIZATION: 7
}